<template>
  <section>
    <inner-surevy-page-header
      :links="links"
      :surveyData="surveyData"
      :type="'YES'"
    />
    <persona-filter></persona-filter>

    <div class="survey-charts-container mt-4 pb-4" ref="surveyChartsContainer">
      <router-view></router-view>
    </div>
  </section>
</template>

<script>
import PersonaFilter from "@/components/dashboard/surveys-charts/individual/yes-charts/persona-filter.vue";
import { mapGetters } from "vuex";
import InnerSurevyPageHeader from "../../../components/dashboard/surveys-charts/shared/inner-surevy-page-header.vue";

export default {
  name: "MainSurveyYES",
  components: {
    PersonaFilter,
    InnerSurevyPageHeader,
  },
  data() {
    return {
      showFilter: false,
      links: [
        {
          routeName: "Summary",
          text: "Summary",
        },
        {
          routeName: "Experience",
          text: "Experience",
        },
        {
          routeName: "CommitmentNetwork",
          text: "Commitment & Network",
        },
        {
          routeName: "SurveyDemographicQuestionsYES",
          text: "Demographics",
        },
        {
          routeName: "SurveyYesComments",
          text: "Comments",
        },
      ],
    };
  },
  computed: {
    ...mapGetters("mainStats", {
      surveyData: "getSurveyWithPersonasById",
      questionAnswersPerSectionData: "questionAnswersPerSectionData",
      commentsCounts: "getCommentsCountsData",
      allDriversDataSet: "allDriversDataSet",
      pillarScoresData: "getPillarScoresData",
    }),

    responseRate() {
      return `Response: ${this.surveyData.total}`;
    },

    yesSurveyId() {
      return this.$route.params.id;
    },
  },
  methods: {
    handleScroll(event) {
      if (event.target.scrollTop > 200) {
        this.showFilter = true;
      } else {
        this.showFilter = false;
      }
    },
  },
  async mounted() {
    try {
      await this.$store.dispatch("mainStats/resetAllComments");
      await this.$store.dispatch("mainStats/resetDataUsedInd3");

      this.$store.dispatch("mainStats/fetchOverallDistributionGrouped", {
        surveyId: this.yesSurveyId,
      });

      if (!this.surveyData)
        this.$store.dispatch("mainStats/loadSurveyWithPersonasById", {
          surveyId: this.yesSurveyId,
          multiSurvey: false,
        });

      if (!this.pillarScoresData)
        await this.$store.dispatch("mainStats/fetchPillarScores", {
          surveyId: this.yesSurveyId,
          multiSurvey: false,
        });

      if (!this.allDriversDataSet)
        this.$store.dispatch("mainStats/fetchAllDriversYes", {
          surveyId: this.yesSurveyId,
          multiSurvey: false,
        });

      if (!this.questionAnswersPerSectionData)
        await this.$store.dispatch("mainStats/fetchQuestionAnswersPerSection", {
          surveyId: this.yesSurveyId,
          isDemographic: false,
          multiSurvey: false,
        });

      if (!this.commentsCounts)
        await this.$store.dispatch("mainStats/fetchSurveyCommentsCount", {
          surveyId: this.yesSurveyId,
          multiSurvey: false,
        });
    } catch (error) {
      this.$store.dispatch("dialog/showErrorDialog", {
        error: error,
      });
    }

    this.$refs.surveyChartsContainer?.addEventListener(
      "scroll",
      this.handleScroll
    );
  },

  destroyed() {
    this.$refs.surveyChartsContainer?.removeEventListener(
      "scroll",
      this.handleScroll
    );
    this.$store.dispatch("mainStats/resetStore");
  },
};
</script>

<style lang="scss" scoped>
.survey-charts-container {
  // height: calc(100vh - 12rem);
  height: calc(100vh - 16.3rem);
  overflow: auto;
  padding-right: 1rem;
}
</style>
